import { COMMON_NAMESPACE } from '@porsche-code/kado-i18n';
import { styled } from '@porsche-code/kado-styled-system/jsx';
import { Spacer } from '@porsche-code/kado-ui';
import NotLoggedInIcon from '@porsche-code/kado-ui/icons/not-logged-in.svg?react';
import {
  PButton,
  PHeading,
  PInputPassword,
  PInputText,
} from '@porsche-design-system/components-react';
import { signIn } from 'aws-amplify/auth';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const SignInForm = () => {
  const { t } = useTranslation(COMMON_NAMESPACE);

  const form = useForm({ values: { username: '', password: '' } });

  return (
    <Wrapper>
      <PHeading tag="h3" size="xl">
        {t('signIn.title')}
      </PHeading>
      <Icon />
      <Form
        onSubmit={form.handleSubmit(async ({ username, password }) => {
          try {
            await signIn({ username, password });
          } catch (err) {
            form.setError('username', {
              message: err instanceof Error ? err.message : `${err}`,
            });
          }
        })}
      >
        <PInputText
          {...form.register('username', { required: true })}
          aria-label={t('signIn.fields.username')}
          label={t('signIn.fields.username')}
          message={form.formState.errors.username?.message}
          state={
            form.formState.errors.username &&
            form.formState.touchedFields.username
              ? 'error'
              : 'none'
          }
        />

        <Spacer mb="md" />

        <PInputPassword
          {...form.register('password', { required: true })}
          aria-label={t('signIn.fields.password')}
          label={t('signIn.fields.password')}
          message={form.formState.errors.password?.message}
          state={
            form.formState.errors.password &&
            form.formState.touchedFields.password
              ? 'error'
              : 'none'
          }
        />

        <Spacer mb="md" />

        <PButton
          aria-label={t('signIn.submit')}
          loading={form.formState.isSubmitting}
          type="submit"
        >
          {t('signIn.submit')}
        </PButton>
      </Form>
    </Wrapper>
  );
};

const Wrapper = styled('div', {
  base: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'xl',
  },
});

const Icon = styled(NotLoggedInIcon, {
  base: {
    fontSize: '180px',
    my: 'xl',
    mx: 0,
  },
});

const Form = styled('form', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    width: 350,
  },
});
